module.exports = __webpack_public_path__ + "static/Carly_Daniel9-09094965114b882016101dbe02807dd4.jpg";